import { Button, LoadingSpinner } from '../../Generic'
import { observer } from 'mobx-react'
import { useContext } from 'react'
import { StoreContext } from '@store/Root.store'

import { cx } from '@/utils/cx'

interface SendSmsStatusProps {
  disabled: boolean
  counting: boolean
  isRedirecting: boolean
  isSendSmsButtonVisible: boolean
  sendSmsCount: number
  smsMaxAttempts: number
  countdownProgress: number
  sendSms: () => void
  tabIndex?: number
}

export const SendSmsStatus = observer(
  ({
    disabled,
    counting,
    isRedirecting,
    isSendSmsButtonVisible,
    sendSmsCount,
    smsMaxAttempts,
    countdownProgress,
    sendSms,
    tabIndex = 0,
  }: SendSmsStatusProps) => {
    const store = useContext(StoreContext)
    const { switchToMobile: trans } = store.TranslationsState.translationsNew

    const sendSmsButtonText =
      sendSmsCount < 1 ? trans.scanQr.sendSmsBtn : trans.scanQr.sendSmsAgainBtn

    return (
      <>
        {!isSendSmsButtonVisible && (
          <div className="switch-to-mobile__centered-sms-text">
            <p>{trans.scanQr.smsSent}</p>
          </div>
        )}

        <Button
          disabled={
            disabled ||
            counting ||
            isRedirecting ||
            !isSendSmsButtonVisible ||
            sendSmsCount >= smsMaxAttempts
          }
          onClick={sendSms}
          tabIndex={tabIndex}
          className="button--secondary switch-to-mobile__sms-btn"
        >
          {counting && <LoadingSpinner inButton />}
          <span className={cx('generic__button-text', counting && 'generic__button-text--loading')}>
            {sendSmsButtonText}
          </span>
        </Button>

        {!isSendSmsButtonVisible && sendSmsCount < smsMaxAttempts && (
          <div className="switch-to-mobile__centered-sms-text">
            <p>{trans.scanQr.smsNotReceived}</p>

            <p>{trans.scanQr.sendSmsAgain.replace('<number>', countdownProgress.toString())}</p>
          </div>
        )}
      </>
    )
  }
)
